<template>
  <v-btn
    v-if="type === 'button'"
    v-bind="$attrs"
    :loading="loading"
    color="error"
    @click="logout"
  >
    <v-icon class="mr-1" dark>exit_to_app</v-icon>
    Logout
  </v-btn>
</template>

<script>
export default {
  name: "logout-link",

  props: {
    type: {
      type: String,
      default: "link"
    }
  },

  data() {
    return {
      loading: false
    };
  },

  methods: {
    async logout() {
      try {
        this.loading = true;

        await this.$store.dispatch("auth/logOut");

        this.$router.replace({ name: "landing-page" }, () => {
          window.location.reload();
        });
      } catch (error) {
        this.$notify.error({
          title: "Logout failed",
          message: error.message
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
